module.exports = __webpack_public_path__ + "img/cille.34ee8f86.png";